import React, { useEffect } from "react";

import { Card } from "pages/[tenant]/search/components/atoms/Card";
import TagCard from "pages/[tenant]/search/components/atoms/TagCard";
import { CardsList } from "pages/[tenant]/search/components/atoms/molecules/CardsList";
import SearchFilters from "pages/[tenant]/search/components/molecules/SearchFilters";
import FilterModal from "pages/[tenant]/search/components/organisms/FilterModal";
import { useGetGroups } from "pages/[tenant]/search/hooks/useGetGroups";
import { useGetLessons } from "pages/[tenant]/search/hooks/useGetLessons";
import { useNewGlobalSearch } from "pages/[tenant]/search/hooks/useNewGlobalSearch";

import CircularLoader from "shared/components/atoms/CircularLoader";
import { SearchInput } from "shared/components/atoms/SearchInput";
import { useOrganizationConfig } from "shared/hooks/useOrganizationConfig";
import { useGroupSearch } from "shared/providers/Layout/components/NewTopBar/hooks/useGroupsSearch";
import { useTopbarContext } from "shared/providers/Layout/hooks/useTopbarContext";
import { useFeature } from "shared/utils/hooks/useFeature";

import {
  Empty,
  ModalSection,
  SearchContainer,
  SearchInputContainer,
  TagsSection,
} from "./styles";

export const Search = () => {
  const isAdvancedSearchEnabled = useFeature("f_advanced_global_search");

  const {
    listToIterate,
    itemsWasFounded,
    clearSearchResult,
    searchInList,
    showModal,
    selectedTags,
    selectedAuthors,
    isFiltering,
    setIsFiltering,
    isLoading,
    setIsLoading,
  } = useNewGlobalSearch();

  const { getLessons } = useGetLessons();
  const { getGroups, isLoadingGroups } = useGetGroups();

  const { searchIsOpen, closeSearch } = useTopbarContext();

  const { getOrganizationFromCookies } = useOrganizationConfig();
  const organizationInCookie = getOrganizationFromCookies();

  const orgId = organizationInCookie?.id?.toString() ?? "0";

  const { isAbleToFetchGroups, setAlreadyFetchedGroups, hasErrorInRequest } =
    useGroupSearch();

  useEffect(() => {
    const initialFetch = async () => {
      try {
        setIsLoading(true);
        await getGroups(orgId);
        setAlreadyFetchedGroups();
      } catch (e) {
        console.log(e);
      } finally {
        setIsLoading(false);
      }
    };

    const shouldFetchGroups = isAbleToFetchGroups && searchIsOpen;

    if (shouldFetchGroups) initialFetch();
  }, [searchIsOpen, isAbleToFetchGroups, hasErrorInRequest]);

  useEffect(() => {
    getLessons(orgId);
  }, []);

  useEffect(() => {
    if (
      selectedTags?.length <= 0 &&
      selectedAuthors?.length <= 0 &&
      isFiltering
    ) {
      clearSearchResult();
      setIsFiltering(false);
    }
  }, [selectedTags, selectedAuthors]);

  const itemsToList = [...selectedTags, ...selectedAuthors];

  return (
      <>
    <SearchContainer show={searchIsOpen}>
        <SearchInputContainer>
          <SearchInput
            clearSearchMethod={clearSearchResult}
            searchListMethod={searchInList}
            withSearchAndXIcon
          />
          {isAdvancedSearchEnabled && <SearchFilters />}
        </SearchInputContainer>

        {isAdvancedSearchEnabled && isFiltering && (
          <TagsSection>
            {itemsToList?.map((tag) => (
              <TagCard tag={tag} key={tag?.id} />
            ))}
          </TagsSection>
        )}

        {isLoading || isLoadingGroups ? (
          <div className="loader-container">
            <CircularLoader className="loader" />
          </div>
        ) : (
          <>
            {itemsWasFounded ? (
              <CardsList isInSearchPage={true}>
                {listToIterate?.map((item) => (
                  <Card key={item?.id + item?.slug} item={item} onClick={closeSearch}/>
                ))}
              </CardsList>
            ) : (
              <Empty>Nenhum resultado foi encontrado.</Empty>
            )}
          </>
        )}

      </SearchContainer>
        {showModal && (
          <ModalSection>
            <FilterModal />
          </ModalSection>
        )}
      </>
  );
};
